import { formatSubscriptionDate } from './academicYear';
import { PRICE_PER_CLASS_YEAR } from '../constants/invoiceIssuer';

export function buildRenewalWhatsAppUrl(head, { useMalayalam = false } = {}) {
  const name = head?.name || head?.username || 'School';
  const exp = formatSubscriptionDate(head?.subscription_expires_at);
  const classes = parseInt(head?.divisions, 10) || 0;
  const fee = classes * PRICE_PER_CLASS_YEAR;

  const text = useMalayalam
    ? `നമസ്കാരം ${name},\n\nNMhelper പ്ലാൻ ${exp} ന് അവസാനിക്കുന്നു.\n\nക്ലാസുകൾ: ${classes}\nവാർഷിക നിരക്ക്: ₹${fee}\n\nപുതുക്കാൻ UPI/ബാങ്ക് വിവരങ്ങൾക്ക് മറുപടി നൽകുക. നന്ദി.\n— NMhelper`
    : `Hello ${name},\n\nYour NMhelper plan expires on ${exp}.\n\nClasses: ${classes}\nYearly fee: ₹${fee}\n\nReply for UPI/bank details to renew. Thank you.\n— NMhelper`;

  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}
